import { render, staticRenderFns } from "./CommAuth.vue?vue&type=template&id=7ce562cc&scoped=true&"
import script from "./CommAuth.vue?vue&type=script&lang=js&"
export * from "./CommAuth.vue?vue&type=script&lang=js&"
import style0 from "./CommAuth.vue?vue&type=style&index=0&id=7ce562cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce562cc",
  null
  
)

export default component.exports